import { useState, useEffect } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from './TabPanel';
import { setTabOnFocus } from '../../store/global/actions';
import { marginBottomForBreadCrumb } from '../../config/styles';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumb from '../atoms/breadcrumb/';
import { getTabOnFocus, getElementOnFocus } from '../../store/global/selectors';
import Divider from '@material-ui/core/Divider';
import { Grid } from '@material-ui/core';
import { handleSnackBar } from '../../store/global/actions';
import { toggleRightDrawer } from '../../store/global/actions'
import { getAssets } from "../../store/assets/selectors";
import UploadAsset from "../molecules/assets/UploadAsset";
import CreateFolder from "../molecules/assets/CreateFolder";
import RenameAsset from "../molecules/assets/RenameAsset";

export default function Assets({ element }) {

    const dispatch = useDispatch();
    const tabOnFocus = useSelector(getTabOnFocus);
    const assets = useSelector(getAssets);
    const elementOnFocus = useSelector(getElementOnFocus);

    console.log(elementOnFocus,'FOCUS ELEMENT');

    const immediateParent = assets.find(item => item?._id === elementOnFocus.parent)
    const secondImmediateParent = assets.find(item => item?._id === immediateParent?.parent) ? assets.find(item => item?._id === immediateParent?.parent) : null
    // console.log("immediateParent", immediateParent)

    const [openTab, setOpenTab] = useState(0);
    const [action, setAction] = useState(0);

    const detailsBC = [
        { label: 'Assets', url: null },
    ];

    if (secondImmediateParent) detailsBC.push({ label: secondImmediateParent?.assetName, url: null })
    if (immediateParent) detailsBC.push({ label: immediateParent?.assetName, url: null })


    useEffect(() => {
        setOpenTab(tabOnFocus);
    }, [tabOnFocus])

    const onCompletion = (type, action, status, message) => {

        if (action != undefined) {
            console.log(action,'this is action');
            switch (action) {
                case 'add':
                    if (status === true) dispatch(handleSnackBar({ open: true, message: `${type} created`, severity: "success" }));
                    else dispatch(handleSnackBar({ open: true, message: `${type} couldn't create`, severity: "error" }));
                    dispatch(toggleRightDrawer());
                    break;
                case 'upload':
                    dispatch(toggleRightDrawer());
                    break;
                case 'rename':
                    if (status === true) dispatch(handleSnackBar({ open: true, message: `${type} renamed`, severity: "success" }));
                    else dispatch(handleSnackBar({ open: true, message: `Asset couldn't rename`, severity: "error" }));
                    // dispatch(toggleRightDrawer());
                    break;

            }
            setAction({})
        }
    }

    const onClose = () => {
        dispatch(toggleRightDrawer());
        setAction({});
    }

    return (
        <>
            <AppBar position="static">
                <Tabs value={openTab} onChange={(e, v) => { dispatch(setTabOnFocus(v)); setOpenTab(v) }} aria-label="simple tabs example">
                    <Tab label={elementOnFocus.type === 'assets_rename' ? 'Rename' : 'assets_file' ? "Upload" : "Create"} />
                </Tabs>
            </AppBar>


            <TabPanel value={openTab} index={0} >
                <Grid container direction={"row"} spacing={2}>

                    <Grid item xs={8}>
                        <BreadCrumb items={detailsBC} />
                    </Grid>

                </Grid>

                <Divider style={marginBottomForBreadCrumb} />


                {elementOnFocus.type === 'assets_file' && <UploadAsset onCompletion={onCompletion} onClose={onClose} parent={elementOnFocus.parent} />}

                {elementOnFocus.type === 'assets_folder' && <CreateFolder onCompletion={onCompletion} onClose={onClose} parent={elementOnFocus.parent} />}

                {elementOnFocus.type === 'assets_rename' && <RenameAsset onCompletion={onCompletion} onClose={onClose} item={elementOnFocus.item} />}

            </TabPanel>

        </>
    )
}